import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_PROMPT_FRAGMENT } from "../prompt-fragment.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdatePromptFragmentInput } from "../../../__generated__/globalTypes";
import {
  UpdatePromptFragmentMutation,
  UpdatePromptFragmentMutationVariables,
} from "../../../__generated__/UpdatePromptFragmentMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdatePromptFragment = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdatePromptFragmentInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdatePromptFragmentMutation,
    UpdatePromptFragmentMutationVariables
  >(UPDATE_PROMPT_FRAGMENT, {
    refetchQueries: ["PromptFragmentsQuery", "PromptFragmentQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updatePromptFragment?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updatePromptFragment?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
